export function TextUpperCase(a) {
    return a.toUpperCase();
  }

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function sessionStoragegetItem(Key)
{
    return sessionStorage.getItem(Key);
}
